import React, { useEffect, useState } from 'react';
import PopAdminPresenter from "@/presenters/screens/pop-admin.presenter";
import { SingleCollapse } from "@/components/";
import Test2Years from './DetailYears';
import { MasterDataGrid } from "@/components/";

export interface IPropsStep {
    columns: any,
    data: any,
    stepsData: any,
    sectionName: any,
    section: string,
    year: any
}

const DetailIndicator: React.FC<IPropsStep> = ({columns, data, stepsData, sectionName, section, year} : IPropsStep) => {
    const [dataSource, setDataSource] = useState<any>(null);
    const [dataColumns, setDataColumns] = useState<any>(null);

    const view: any = {
        state: {
            columns,
            dataColumns,
            data,
            stepsData,
            year,
            setDataSource,
        },
    };
      
    const presenter = new PopAdminPresenter(view);
    
    useEffect(() => {
        if(!!data?.length && columns){
            let auxCol = presenter.getIndType2Columns(presenter.formMastersFollowup, section)
            setDataColumns(auxCol)
        }
    }, [data, columns])

    return (
        <>
            {(dataColumns && dataSource && !!data?.length) && 
                <SingleCollapse title={sectionName} isOpen={false}>
                    <>
                        <MasterDataGrid
                            id={sectionName}
                            dataSource={dataSource}
                            columns={dataColumns}
                            allowCode={"view"}
                            gridProps={{
                                editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                                rowAlternationEnabled:false,
                                selection:{
                                    mode:"single"
                                }
                            }}
                        />  
                        <Test2Years 
                            onSelectionChanged={onselectionchange}  
                            data={[]} 
                            id={`asdasd-detail`}
                            gridId={sectionName}   
                            dataColumns={columns}      
                        />          
                    </>    
                </SingleCollapse>
            }
        </>
    )
}

export default DetailIndicator;